import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable');
}

if (!supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: window.localStorage,
    storageKey: 'supabase.auth.token',
    // IMPORTANT: keep this as 'implicit' (with detectSessionInUrl).
    //
    // Magic links MUST use the implicit flow. PKCE requires the one-time
    // code verifier to live in the SAME browser/localStorage that requested
    // the link, so PKCE magic links break when the link is opened on a
    // different device or when an email client / link-scanner pre-fetches
    // the one-time URL — the user gets bounced back to the site
    // unauthenticated. The implicit flow puts the token directly in the
    // returned URL, so the session is established no matter where the link
    // is opened. A past "security hardening" pass silently flipped this to
    // 'pkce' and reintroduced the broken-login bug; do NOT switch it back
    // without a dedicated cross-device magic-link callback (verifyOtp /
    // token_hash) in place first.
    detectSessionInUrl: true,
    flowType: 'implicit'
  },
});
